// This is a generated file!
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _define = require("../../define");
const iconSkTemplate = document.createElement('template');
iconSkTemplate.innerHTML = '<svg class="icon-sk-svg" xmlns="http://www.w3.org/2000/svg" width=24 height=24 viewBox="0 0 24 24"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>';
(0, _define.define)('content-copy-icon-sk', class extends HTMLElement {
    connectedCallback() {
        const icon = iconSkTemplate.content.cloneNode(true);
        while(this.firstChild){
            this.removeChild(this.firstChild);
        }
        this.appendChild(icon);
    }
});
